import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { IOrganizationsUploadJobDetails, IPassportConfigurationUploadJobResult } from '../../../api/jobs.dao';
import { AlertErrorMessage } from '../../global/modal/alerts-host/types/alert/alert-error-message';
import React from 'react';

const passportConfigurationUploadJobProperties: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IOrganizationsUploadJobDetails>> = {
    reviewFailedJobButtonText: 'Ok',
    reviewCompletedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IOrganizationsUploadJobDetails, IPassportConfigurationUploadJobResult>) => {
        const { passportSettings, failureReason: jobFailureReason, customPageFailureReason, emailConfigurationForm } = props.result;
        const {
            menuBarLogoImageSuccessfulUpload,
            logoImageSuccessfulUpload,
            backgroundImageSuccessfulUpload,
            footerLogoImageSuccessfulUpload
        } = passportSettings;

        const emailLogoImageSuccessfulUpload = emailConfigurationForm.logoImageSuccessfulUpload;

        const uploadData = [
            { value: menuBarLogoImageSuccessfulUpload, label: 'Menu bar logo image' },
            { value: logoImageSuccessfulUpload, label: 'Logo image' },
            { value: backgroundImageSuccessfulUpload, label: 'Background image' },
            { value: footerLogoImageSuccessfulUpload, label: 'Footer logo image' },
            { value: emailLogoImageSuccessfulUpload, label: 'Email logo image' },
        ];

        const failReasons = [jobFailureReason, customPageFailureReason];

        return <div className='alert-content'>
            <div className='alert-content__item'>Upload successful.</div>
            {uploadData.map((upload, index) => upload.value === false &&
                <div className='alert-content__item' key={index}>{`${upload.label} could not be found in the original event, and was not updated.`}</div>
            )}
            {failReasons.map((failReason, index) => !!failReason &&
                <div className='alert-content__item' key={index}>{failReason}</div>
            )}
        </div>;
    },
    failedComponent: (props: IJobResultComponentProps<IOrganizationsUploadJobDetails, IPassportConfigurationUploadJobResult>) => {
        return <AlertErrorMessage title='Upload Failed' message={props.result?.errorMessage || 'Unknown failure reason'} />;
    },
};

export { passportConfigurationUploadJobProperties };